import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Button, TextInput } from "@tremor/react";

import { adminAPI } from "../../api/adminAPI";
import { AlertBox } from "../../ui";
import { useForm } from "react-hook-form";

export const RegisterStatusModal = ({ cancelFunction, getStatus }) => {
  const { jwt } = useSelector((state) => state.auth);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const watchCustom = watch("isCustomInput", false);

  const setCustomInputValue = (e) => {
    const event = {
      target: {
        name: "isCustomInput",
        value: e.target.checked,
      },
    };
  };

  const setBlankInputValue = (e) => {
    const event = {
      target: {
        name: "isBlankInput",
        value: e.target.checked,
      },
    };
    // onInputChange(event);
  };

  const onSubmit = async (dataForm) => {
    // if (!isFormValid) return;
    // const dataForm = {
    //   isCustomInput,
    //   isBlankInput: isCustomInput ? isBlankInput : false,
    //   name,
    // };
    const headers = {
      "x-token": jwt,
    };
    const resp = await adminAPI
      .post("/status", dataForm, { headers })
      .catch(({ response }) => response);
    const { data } = resp;
    if (resp.status !== 200) {
      const errors = data.message
        ? [data.message]
        : data.errors.map((err) => err.msg);
      AlertBox({ color: "warning", messages: errors });
    }
    AlertBox({ color: "success", messages: [data.message] });
    getStatus();
    cancelFunction();
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="bg-white p-6 rounded shadow-lg z-10">
        <h2 className="text-xl font-bold mb-4">Registrar Nuevo Estatus</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <p>Nombre</p>
            <TextInput
              name="name"
              placeholder="Estatus 1"
              {...register("name", {
                required: { value: true, message: "El nombre es requerido" },
                minLength: {
                  value: 3,
                  message: "El nombre debe tener al menos 3 caracteres",
                },
              })}
            />
            {errors.name && (
              <span className="text-red-500 text-sm">
                {errors.name.message}
              </span>
            )}
          </div>
          <div>
            <label>
              <input
                type="checkbox"
                placeholder="Hola que tal"
                onChange={setCustomInputValue}
                {...register("isCustomInput")}
              />
              <span>Debe ser un Estatus Custom?</span>
            </label>
            {errors.isCustomInput && (
              <span className="text-red-500 text-sm">
                {errors.isCustomInput.message}
              </span>
            )}
          </div>
          <div className={watchCustom ? `opacity-100` : `opacity-0`}>
            <label>
              <input
                type="checkbox"
                placeholder="Hola que tal"
                onChange={setBlankInputValue}
                {...register("isBlankInput")}
              />
              <span>Puede Ingresar cualquier Información?</span>
            </label>
            {errors.isBlankInput && (
              <span className="text-red-500 text-sm">
                {errors.isBlankInput.message}
              </span>
            )}
          </div>
          <div className="flex justify-between mt-2">
            <Button variant="secondary" onClick={cancelFunction}>
              Cerrar
            </Button>
            <Button type="submit">Guardar</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

RegisterStatusModal.propTypes = {
  cancelFunction: PropTypes.func,
  getStatus: PropTypes.func,
};
